import {auth, setUserControl} from "../api/user";

export const baseImg = {
  data() {
    return {
      baojinjiechu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingjiechu.png`),
      baojinjiechuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingjiechu2.png`),
      baojinjiechuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingjiechu.png`),
      baojinqueren: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingqueren.png`),
      baojinquerenEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingqueren2.png`),
      baojinquerenLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/baojingqueren.png`),
      bofang: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofang.png`),
      bofangEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofang2.png`),
      bofangLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofang.png`),
      duijiang: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duijiang.png`),
      duijiangEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duijiang2.png`),
      duijiangLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duijiang.png`),
      duofangguangbo: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofangguangbo.png`),
      duofangguangboEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofangguangbo2.png`),
      duofangguangboLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofangguangbo.png`),
      duofanghuiyi: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofanghuiyi.png`),
      shipinhuiyi: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shipinhuiyi.png`),
      shipinhuiyiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shipinhuiyi2.png`),
      shipinhuiyiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shipinhuiyi.png`),
      duofanghuiyiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofanghuiyi2.png`),
      duofanghuiyiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/duofanghuiyi.png`),
      fenzu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzu.png`),
      fenzuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzu2.png`),
      fenzuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzu.png`),
      fenzuhanhua: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzuhanhua.png`),
      fenzuhanhuaEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzuhanhua2.png`),
      fenzuhanhuaLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/fenzuhanhua.png`),
      gengxin: require(`@/assets/images/bottom/${this.$store.state.app.theme}/gengxin.png`),
      gengxinEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/gengxin2.png`),
      gengxinLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/gengxin.png`),
      guaduan: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guaduan.png`),
      guaduanEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guaduan2.png`),
      guaduanLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guaduan.png`),
      guanbihuiyi: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guanbihuiyi.png`),
      guanbihuiyiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guanbihuiyi2.png`),
      guanbihuiyiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/guanbihuiyi.png`),
      hujiao: require(`@/assets/images/bottom/${this.$store.state.app.theme}/hujiao.png`),
      hujiaoEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/hujiao2.png`),
      hujiaoLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/hujiao.png`),
      jianting: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jianting.png`),
      jiantingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jianting2.png`),
      jiantingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jianting.png`),
      jieshu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jieshu.png`),
      jieshuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jieshu2.png`),
      jieshuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jieshu.png`),
      jingyin: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jingyin.png`),
      jingyinEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jingyin2.png`),
      jingyinLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/jingyin.png`),
      kaishihuiyi: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kaishihuiyi.png`),
      kaishihuiyiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kaishihuiyi2.png`),
      kaishihuiyiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kaishihuiyi.png`),
      kongxian: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kongxian.png`),
      kongxianEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kongxian.png`),
      kongxianLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/kongxian2.png`),
      liandong: require(`@/assets/images/bottom/${this.$store.state.app.theme}/liandong.png`),
      liandongEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/liandong2.png`),
      liandongLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/liandong.png`),
      luxiangjilu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/luxiangjilu.png`),
      luxiangjiluEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/luxiangjilu2.png`),
      luxiangjiluLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/luxiangjilu.png`),
      miyu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/miyu.png`),
      miyuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/miyu2.png`),
      miyuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/miyu.png`),
      paiduitongzhi: require(`@/assets/images/bottom/${this.$store.state.app.theme}/paiduitongzhi.png`),
      paiduitongzhiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/paiduitongzhi2.png`),
      paiduitongzhiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/paiduitongzhi.png`),
      piliangshanchu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/piliangshanchu.png`),
      piliangshanchuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/piliangshanchu2.png`),
      piliangshanchuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/piliangshanchu.png`),

      qiangcha: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangcha.png`),
      qiangchaEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangcha2.png`),
      qiangchaLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangcha.png`),
      qiangchai: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangchai.png`),
      qiangchaiEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangchai2.png`),
      qiangchaiLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/qiangchai.png`),
      quantijingyin: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quantijingyin.png`),
      quantijingyinEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quantijingyin2.png`),
      quantijingyinLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quantijingyin.png`),
      quxiaojingyin: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaojingyin.png`),
      quxiaojingyinEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaojingyin2.png`),
      quxiaojingyinLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaojingyin.png`),
      quxiaoquantijingyin: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaoquantijingyin.png`),
      quxiaoquantijingyinEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaoquantijingyin2.png`),
      quxiaoquantijingyinLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/quxiaoquantijingyin.png`),
      shanchu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shanchu.png`),
      shanchuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shanchu2.png`),
      shanchuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shanchu.png`),
      xiangqing: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiangqing.png`),
      xiangqingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiangqing2.png`),
      xiangqingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiangqing.png`),
      yaoqing: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yaoqing.png`),
      yaoqingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yaoqing2.png`),
      yaoqingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yaoqing.png`),
      yichu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yichu.png`),
      yichuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yichu2.png`),
      yichuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yichu.png`),
      yinliang: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliang.png`),
      yinliangEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliang2.png`),
      yinliangLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliang.png`),
      yinliangjia: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjia.png`),
      yinliangjiaEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjia2.png`),
      yinliangjiaLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjia.png`),
      yinliangjian: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjian.png`),
      yinliangjianEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjian2.png`),
      yinliangjianLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/yinliangjian.png`),
      zanting: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zanting.png`),
      zantingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zanting2.png`),
      zantingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zanting.png`),
      zengjia: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zengjia.png`),
      zengjiaEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zengjia2.png`),
      zengjiaLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zengjia.png`),
      zhuanjie: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuanjie.png`),
      zhuanjieEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuanjie2.png`),
      zhuanjieLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuanjie.png`),
      zhuapaijilu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuapaijilu.png`),
      zhuapaijiluEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuapaijilu2.png`),
      zhuapaijiluLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhuapaijilu.png`),
      zidongjieting: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zidongjieting.png`),
      zidongjietingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zidongjieting.png`),
      zidongjietingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zidongjieting2.png`),
      lixianrenwu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/lixianrenwu.png`),
      lixianrenwuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/lixianrenwu2.png`),
      lixianrenwuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/lixianrenwu.png`),
      renwutongbu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/renwutongbu.png`),
      renwutongbuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/renwutongbu2.png`),
      renwutongbuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/renwutongbu.png`),
      xiugaiyinliang: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiugaiyinliang.png`),
      xiugaiyinliangEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiugaiyinliang2.png`),
      xiugaiyinliangLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiugaiyinliang.png`),
      shangchuanchangjingtu: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shangchuanchangjingtu.png`),
      shangchuanchangjingtuEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shangchuanchangjingtu2.png`),
      shangchuanchangjingtuLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/shangchuanchangjingtu.png`),
      lixian: require(`@/assets/images/bottom/${this.$store.state.app.theme}/lixian.png`),
      zhenling: require(`@/assets/images/bottom/${this.$store.state.app.theme}/zhenling.png`),
      topImg: require(`@/assets/images/bottom/${this.$store.state.app.theme}/top.png`),
      cameraInterval: require(`@/assets/images/bottom/${this.$store.state.app.theme}/camerafor.png`),
      cameraIntervalEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/camerafor2.png`),
      cameraIntervalLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/camerafor.png`),
      //视频会议相关
      fullScreen: require(`@/assets/images/bottom/${this.$store.state.app.theme}/full.png`),
      fullScreenEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/full2.png`),
      fullScreenLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/full.png`),
      joinMeeting: require(`@/assets/images/bottom/${this.$store.state.app.theme}/join.png`),
      joinMeetingEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/join2.png`),
      joinMeetingLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/join.png`),
      disableCamera: require(`@/assets/images/bottom/${this.$store.state.app.theme}/mute_camera.png`),
      disableCameraEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/mute_camera2.png`),
      disableCameraLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/mute_camera.png`),
      enableCamera: require(`@/assets/images/bottom/${this.$store.state.app.theme}/unMute_camera.png`),
      enableCameraEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/unMute_camera2.png`),
      enableCameraLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/unMute_camera.png`),
      settingImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/setting.png`),
      settingImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/setting2.png`),
      settingImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/setting.png`),

      playVideoRecordImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluxiang.png`),
      playVideoRecordImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluxiang2.png`),
      playVideoRecordImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluxiang.png`),
      playAudioRecordImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluyin.png`),
      playAudioRecordImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluyin2.png`),
      playAudioRecordImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/bofangluyin.png`),
      viewImgRecordImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/chakanjietu.png`),
      viewImgRecordImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/chakanjietu2.png`),
      viewImgRecordImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/chakanjietu.png`),
      downloadImgImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazaijietu.png`),
      downloadImgImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazaijietu2.png`),
      downloadImgImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazaijietu.png`),
      downloadVideoImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuxiang.png`),
      downloadVideoImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuxiang2.png`),
      downloadVideoImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuxiang.png`),
      downloadAudioImage: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuyin.png`),
      downloadAudioImageEnter: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuyin2.png`),
      downloadAudioImageLeave: require(`@/assets/images/bottom/${this.$store.state.app.theme}/xiazailuyin.png`),

      imgList: ['baojinjiechu', 'baojinqueren', 'bofang', 'duijiang', 'duofangguangbo', 'duofanghuiyi', 'shipinhuiyi', 'fenzu', 'fenzuhanhua', 'gengxin', 'guaduan', 'guanbihuiyi', 'hujiao',
        'jianting', 'jieshu', 'jingyin', 'quxiaojingyin', 'kaishihuiyi', 'kongxian', 'liandong', 'luxiangjilu', 'miyu', 'paiduitongzhi', 'piliangshanchu', 'qiangcha', 'qiangchai', 'quantijingyin',
        'quxiaoquantijingyin', 'shanchu', 'xiangqing', 'yaoqing', 'yichu', 'yinliang', 'yinliangjia', 'yinliangjian', 'zanting', 'zengjia', 'zhuanjie', 'zhuapaijilu',
        'lixianrenwu', 'renwutongbu', 'xiugaiyinliang', 'shangchuanchangjingtu', 'cameraInterval', 'fullScreen', 'joinMeeting', 'disableCamera', 'enableCamera', 'settingImage',
        'bofangluxiang','bofangluyin','chakanjietu','xiazaijietu','xiazailuxiang','xiazailuyin'],
      //logo
      logoEN: this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`][`${this.$store.state.app.theme}Logo`].en,
      logoCN: this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`][`${this.$store.state.app.theme}Logo`].zh,
      logoTW: this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`][`${this.$store.state.app.theme}Logo`].tw,
      buttonWidth1: {width: '100px'},
      //图标名称
      broad_svg: 'broad',
      car_svg: 'car',
      conf_svg: 'conf',
      confMute_svg: 'conf_mute',
      connected_svg: 'connected',
      door_svg: 'door',
      full_svg: 'full',
      idel_svg: 'idel',
      leftIcon_svg: 'left_icon',
      logout_svg: 'logout',
      mobile_svg: 'mobile',
      offline_svg: 'offline',
      other_svg: 'other',
      partBroad_svg: 'part_broad',
      partConf_svg: 'part_conf',
      partPro_svg: 'part_pro',
      partDown_svg: 'part_down',
      partUp_svg: 'part_up',
      pc_svg: 'pc',
      ring_svg: 'ring',
      rightIcon_svg: 'right_icon',
      selected_svg: 'selected',
      unselected_svg: 'unselected',
      setting_svg: 'setting',
      speak_svg: 'speak',
      stateIcon_svg: 'state_icon',
      talking_svg: 'talking',
      broading_svg: 'broading_c',
      typeIcon_svg: 'type_icon',
      unconnected_svg: 'unconnected',
      unknow_svg: 'unknow',
      view_svg: 'view',
      voice_svg: 'voice',
      app_svg: 'app_svg',
      //control
      control_offline: 'control-offline',
      control_idle: 'control-idle',
      control_talk: 'control-talk',
      control_ring: 'control-ring',
      control_broad: 'control-broad',
      control_colors:{
        offline:'#9a9a9a',
        idle:'#00d5ff',
        talk:'#01e0c7',
        ring:'#039efc',
        broad:'#ad83e3',
        unknow:'#C0842D',
      },
      whiteControl_colors:{
        // 与主控台卡片一致：空闲蓝 / 通话绿 / 广播粉 / 振铃紫 / 离线灰
        offline:'#999999',
        idle:'#1890ff',
        talk:'#22ba60',
        ring:'#5b6ee1',
        broad:'#e85d9a',
        unknow:'#e89a2e',
      },
      //main
      main_mobile_svg: 'mobile',
      main_speak_svg: 'speak',
      main_broad_svg: 'broad',
      main_door_svg: 'door',
      main_pc_svg: 'pc',
      main_car_svg: 'car',
      main_voice_svg: 'voice',
      main_view_svg: 'view',
      main_other_svg: 'other',
      main_talking_svg: 'talking',
      main_ring_svg: 'ring',
      main_idel_svg: 'idel',
      main_offline_svg: 'offline',
      main_unknow_svg: 'unknow',
      main_app_svg: 'app_svg',
      main_dept_svg:'control_dept_icon',
      main_group_svg:'control_group_icon',
      main_linkman_svg:'control_linkman_icon',
      cascade_refresh: 'cascadeRefresh',
      cas_full_svg: 'casedeFullBlack',
      //地图模块图片
      mapImage: {
        source: {
          //default: require(`@/assets/images/map/v2/default/default_${this.$store.state.app.theme}_${this.$store.state.app.local}.jpg`)
          default: require(`@/assets/images/map/v2/default/default_new_${this.$store.state.app.local}.png`)
        },
        start_point: require(`@/assets/images/map/v2/start_point.png`),
        end_point: require(`@/assets/images/map/v2/end_point.png`),
        mark_point: require(`@/assets/images/map/v2/track_icon.png`),
        offline: require(`@/assets/images/map/v2/d_offline.png`),
        online: require(`@/assets/images/map/v2/d_online.png`),
        ring: require(`@/assets/images/map/v2/d_ring.png`),
        talking: require(`@/assets/images/map/v2/d_talking.png`),
        broading: require(`@/assets/images/map/v2/d_broading.png`),
        unknown: require(`@/assets/images/map/v2/d_unknown.png`),
        camera_offline: require(`@/assets/images/map/v2/c_offline.png`),
        camera_online: require(`@/assets/images/map/v2/c_online.png`),
        camera_unknown: require(`@/assets/images/map/v2/c_unknown.png`),
        app_online: require(`@/assets/images/map/v2/app_online.png`),
        app_offline: require(`@/assets/images/map/v2/app_offline.png`),
        app_talking: require(`@/assets/images/map/v2/app_talk.png`),
        app_ring: require(`@/assets/images/map/v2/app_ring.png`),
        app_broading: require(`@/assets/images/map/v2/app_broading.png`),
        selected: {
          e_offline_svg: 'exten_offline',
          e_online_svg: 'exten_idle',
          e_talk_svg: 'exten_talk',
          e_ring_svg: 'exten_ring',
          e_unknown_svg: 'exten_unknown',
          e_broad_svg: 'exten_broading',
          c_offline_svg: 'camera_offline',
          c_idle_svg: 'camera_idle',
          c_unknow_svg: 'camera_unknow',
          a_online_svg: 'app_idle',
          a_offline_svg: 'app_offline',
          a_talk_svg: 'app_talk',
          a_ring_svg: 'app_ring',
          a_broad_svg: 'app_broading',
          a_svg:'app_icon',
          e_svg:'exten_icon',
          c_svg:'camera_icon'
        },
        options: {
          review: 'map_black_review',
          distance: 'map_black_distance',
          circle: 'map_black_circle',
          box: 'map_black_box',
          fence: 'map_black_fence',
          zoomout: 'map_black_zoomout',
          zoomin: 'map_black_zoomin',
          upload: 'map_black_upload',
          scene_manager: 'map_black_scene_manager',
          track: 'map_black_track',
          view: 'map_view',
          view_off: 'mapviewoff',
          lock: 'map_lock',
          unlock: 'map_unlock',
        }
      },
      header_top_left: 'top-left',
      header_top_mean: 'top-mean',
      header_top_mean_b: 'top-mean-b',
      control_video: 'control_video',
      control_voice: 'control_voice',

      //基本图片
      control_hangup: require(`@/assets/images/bottom/control_hangup.png`),
      isBlackTheme: false,
    }
  },
  methods:{
    changeImage(img, type) {
      if (this.imgList.indexOf(img) > -1) {
        if (type === 'Enter' || type === 'Leave') {
          this[`${img}`] = this[`${img + type}`]
        }
      }
    },
    setUseControl(control){
      setUserControl({control:control}).then(res => {
        let response = res.data
        let code = response.code
        if (code !== 200) {
          this.$Message.warning(this.$t('operate_fail'))
        }
      })
    },
    toControl(page){
      let url = this.$config.sysUrl
      let lang = this.$i18n.locale
      //参数加密URL加密，防止出现特殊字符#
      let login_name = encodeURIComponent(this.$store.state.user.userName)
      let login_pass = encodeURIComponent(this.$store.state.user.password)
      let form = {userAccount: login_name, password: login_pass}
      auth(form).then(res => {
        let response = res.data
        let code = response.code
        if (code === 200) {
          let token = response.data.token
          let uri = 'transferLogin?lang=' + lang + '&token=' + token + '&userAccount=' + login_name+ '&timeStamp=' + login_pass;
          if (page) {
            uri = uri + '&toWhere='+page
          }
          if (url === undefined || url === '') {
            url = window.location.protocol + '//' + window.location.host + '/epx/#' + uri
          } else {
            url = url.replace("control","/epx/#")
            url = url.replace("YunEasy/upload","epx/#")
            url = url + uri
          }
          localStorage.removeItem("user");
          var win
          var name = 'blank'
          win = window.open('', name)
          try {
            // 解析目标URL的域名
            const targetUrl = new URL(url)
            const targetOrigin = targetUrl.origin

            // 检查窗口是否有效且可访问
            if (win && win.location) {
              // 获取当前窗口的origin
              let currentOrigin = ''
              try {
                currentOrigin = win.location.origin
              } catch (e) {
                // 跨域访问被阻止，无法获取origin，需要重新打开
              }

              // 判断条件：
              // 1. 窗口是空白页
              // 2. 窗口已关闭
              // 3. 窗口的origin与目标origin不匹配
              // 4. 窗口不在我们的目标域下（考虑URL可能被重定向的情况）
              const shouldOpenNew =
                win.location.href === 'about:blank' ||
                win.closed ||
                !currentOrigin ||
                currentOrigin !== targetOrigin ||
                !win.location.href.includes('epx/#')

              if (shouldOpenNew) {
                // 关闭旧窗口，重新打开
                win.close()
                win = window.open(url, name)
              } else {
                // 聚焦到已打开的窗口
                win.focus()
              }
            } else {
              // 窗口无效，重新打开
              win = window.open(url, name)
            }
          } catch (e) {
            console.error('Window handling error:', e)
            // 出错时尝试重新打开
            win.close()
            win = window.open(url, name)
          }
        }
      }).catch()

    },
    toNewControl(){
      let url = this.$config.sysUrl
      let lang = this.$i18n.locale
      let userName = this.$store.state.user.userName
      let login_pass = encodeURIComponent(this.$store.state.user.password)
      let form = {userAccount: userName, password: login_pass}
      auth(form).then(res => {
        let response = res.data
        let code = response.code
        if (code === 200) {
          let token = response.data.token
          let uri = 'transferLogin?lang=' + lang + '&token=' + token + '&userAccount=' + userName+ '&timeStamp=' + login_pass;
          if (url === undefined || url === '') {
            url = window.location.protocol + '//' + window.location.host + '/epx/#' + uri
          } else {
            url = url.replace("control","/epx/#")
            url = url.replace("YunEasy/upload","epx/#")
            url = url + uri
          }
          localStorage.removeItem("user");
          var win
          var name = 'blank'
          win = window.open('', name)
          try {
            // 解析目标URL的域名
            const targetUrl = new URL(url)
            const targetOrigin = targetUrl.origin

            // 检查窗口是否有效且可访问
            if (win && win.location) {
              // 获取当前窗口的origin
              let currentOrigin = ''
              try {
                currentOrigin = win.location.origin
              } catch (e) {
                // 跨域访问被阻止，无法获取origin，需要重新打开
              }

              // 判断条件：
              // 1. 窗口是空白页
              // 2. 窗口已关闭
              // 3. 窗口的origin与目标origin不匹配
              // 4. 窗口不在我们的目标域下（考虑URL可能被重定向的情况）
              const shouldOpenNew =
                win.location.href === 'about:blank' ||
                win.closed ||
                !currentOrigin ||
                currentOrigin !== targetOrigin ||
                !win.location.href.includes('epx/#')

              if (shouldOpenNew) {
                // 关闭旧窗口，重新打开
                win.close()
                win = window.open(url, name)
              } else {
                // 聚焦到已打开的窗口
                win.focus()
              }
            } else {
              // 窗口无效，重新打开
              win = window.open(url, name)
            }
          } catch (e) {
            console.error('Window handling error:', e)
            // 出错时尝试重新打开
            win.close()
            win = window.open(url, name)
          }
        }
      })
    },
    mapStatusImg(status,type) {
      if (!type){
        type = 0
      }
      type = Number(type)
      if (!status) {
        return 0 === type ? this.mapImage.offline : (1===type ? this.mapImage.camera_offline : this.mapImage.app_offline)
      }
      status = status.toLowerCase()
      switch (status) {
        case 'offline':
          return 0 === type ? this.mapImage.offline : (1 === type ? this.mapImage.camera_offline : this.mapImage.app_offline)
        case 'idle':
          return 0 === type ? this.mapImage.online : (1 === type ? this.mapImage.camera_online : this.mapImage.app_online)
        case 'ringing':
          return 0===type ? this.mapImage.ring : this.mapImage.app_ring
        case 'talking':
          return 0===type ? this.mapImage.talking : this.mapImage.app_talking
        case 'unknown':
          return 0 === type ? this.mapImage.unknown : this.mapImage.camera_unknown
        case 'broading':
          return 0 === type ? this.mapImage.broading : this.mapImage.app_broading
      }
    },
    mapSelectedSvg(status, type) {
      if (!type){
        type = 0
      }
      type = Number(type)
      if (!status) {
        return 0 === type ? this.mapImage.selected.e_offline_svg : (1===type ? this.mapImage.selected.c_offline_svg : this.mapImage.selected.a_offline_svg)
      }
      status = status.toLowerCase()
      switch (status) {
        case 'offline':
          return 0 === type ? this.mapImage.selected.e_offline_svg : (1 === type ? this.mapImage.selected.c_offline_svg : this.mapImage.selected.a_offline_svg)
        case 'idle':
          return 0 === type ? this.mapImage.selected.e_online_svg : (1 === type ? this.mapImage.selected.c_idle_svg : this.mapImage.selected.a_online_svg)
        case 'ringing':
          return 0===type ? this.mapImage.selected.e_ring_svg : this.mapImage.selected.a_ring_svg
        case 'talking':
          return 0===type ? this.mapImage.selected.e_talk_svg : this.mapImage.selected.a_talk_svg
        case 'unknown':
          return 0 === type ? this.mapImage.selected.e_unknown_svg : this.mapImage.selected.c_unknow_svg
        case 'broading':
          return 0 === type ? this.mapImage.selected.e_broad_svg : this.mapImage.selected.a_broad_svg
      }
    },
    mapSelectSvgByType(type){
      if (!type) {
        type = 0
      }
      switch (type) {
        case 0:
          return 'exten_icon'
        case 1:
          return 'camera_icon'
        case 2:
        case 3:
          return 'app_icon'
        default:
          return ''
      }
    },
    mapModelTypeIcon(modelType) {
      if (modelType == null || modelType === '') return ''
      const typeMap = {
        '1': 'mobile',
        '2': 'speak',
        '3': 'broad',
        '4': 'door',
        '5': 'pc',
        '6': 'car',
        '7': 'voice',
        '8': 'view',
        '-1': 'app_icon',
        '9': 'other',
        '-2': 'view'
      }
      return typeMap[String(modelType)] || ''
    },
    mapModelTypeFilter() {
      const isWhite = this.$store.state.app.theme === 'white'
      return isWhite ? 'brightness(0) opacity(0.30)' : 'brightness(10) opacity(0.45)'
    },
    mapSelectSvgClass(status) {
      let color = ''
      if (!status) {
        status = 'unknown'
      }
      status = status.toLowerCase()
      const newColors = this.$store.state.app.theme === 'white' ? this.whiteControl_colors : this.control_colors
      switch (status) {
        case 'offline':
          color = newColors.offline
          break
        case 'idle':
          color = newColors.idle
          break
        case 'ringing':
          color = newColors.ring
          break
        case 'talking':
          color = newColors.talk
          break
        case 'unknown':
          color = newColors.unknow
          break
        case 'broading':
          color = newColors.broad
          break
      }
      let cls = {fill:color,stroke:color}
      return cls
    },
    controlSvgAndColor(status) {
      const isWhite = this.$store.state.app.theme === 'white'
      const newColors = isWhite ? this.whiteControl_colors : this.control_colors
      // control 系列 SVG 内嵌的是 base64 PNG，颜色已写死，没有 -white 版本，不拼接后缀
      // 蓝色主题 idle=#00d5ff；白色主题对齐 console-web 状态色 + dock 简洁图标（白图标 + 状态色圆底）
      const iconColorFilter = 'brightness(0) saturate(100%) invert(74%) sepia(89%) saturate(2500%) hue-rotate(157deg) brightness(105%) contrast(105%)'
      let data = {
        icon: isWhite ? 'dock-phone' : this.control_offline,
        color: newColors['offline'],
        filter: ''
      }
      if (!status) {
        return data
      }
      switch (status.toLowerCase()) {
        case 'talking':
          data.icon = isWhite ? 'dock-phone' : this.control_talk
          data.color = newColors['talk']
          break
        case 'offline':
          data.icon = isWhite ? 'dock-phone' : this.control_offline
          data.color = newColors['offline']
          break
        case 'idle':
          data.icon = isWhite ? 'dock-phone' : this.control_idle
          data.color = newColors['idle']
          data.filter = isWhite ? '' : iconColorFilter
          break
        case 'ringing':
          data.icon = isWhite ? 'dock-phone' : this.control_ring
          data.color = newColors['ring']
          break
        case 'broading':
          data.icon = isWhite ? 'dock-broad' : this.control_broad
          data.color = newColors['broad']
          break
      }
      return data
    },
  },
  watch:{
    '$store.state.app.theme':{
      deep:true,
      immediate:true,
      handler(val) {
        this.isBlackTheme = val != 'white'
        this.baojinjiechu = require(`@/assets/images/bottom/${val}/baojingjiechu.png`)
        this.baojinjiechuEnter = require(`@/assets/images/bottom/${val}/baojingjiechu2.png`)
        this.baojinjiechuLeave = require(`@/assets/images/bottom/${val}/baojingjiechu.png`)
        this.baojinqueren = require(`@/assets/images/bottom/${val}/baojingqueren.png`)
        this.baojinquerenEnter = require(`@/assets/images/bottom/${val}/baojingqueren2.png`)
        this.baojinquerenLeave = require(`@/assets/images/bottom/${val}/baojingqueren.png`)
        this.bofang = require(`@/assets/images/bottom/${val}/bofang.png`)
        this.bofangEnter = require(`@/assets/images/bottom/${val}/bofang2.png`)
        this.bofangLeave = require(`@/assets/images/bottom/${val}/bofang.png`)
        this.duijiang = require(`@/assets/images/bottom/${val}/duijiang.png`)
        this.duijiangEnter = require(`@/assets/images/bottom/${val}/duijiang2.png`)
        this.duijiangLeave = require(`@/assets/images/bottom/${val}/duijiang.png`)
        this.duofangguangbo = require(`@/assets/images/bottom/${val}/duofangguangbo.png`)
        this.duofangguangboEnter = require(`@/assets/images/bottom/${val}/duofangguangbo2.png`)
        this.duofangguangboLeave = require(`@/assets/images/bottom/${val}/duofangguangbo.png`)
        this.duofanghuiyi = require(`@/assets/images/bottom/${val}/duofanghuiyi.png`)
        this.shipinhuiyi = require(`@/assets/images/bottom/${val}/shipinhuiyi.png`)
        this.shipinhuiyiEnter = require(`@/assets/images/bottom/${val}/shipinhuiyi2.png`)
        this.shipinhuiyiLeave = require(`@/assets/images/bottom/${val}/shipinhuiyi.png`)
        this.duofanghuiyiEnter = require(`@/assets/images/bottom/${val}/duofanghuiyi2.png`)
        this.duofanghuiyiLeave = require(`@/assets/images/bottom/${val}/duofanghuiyi.png`)
        this.fenzu = require(`@/assets/images/bottom/${val}/fenzu.png`)
        this.fenzuEnter = require(`@/assets/images/bottom/${val}/fenzu2.png`)
        this.fenzuLeave = require(`@/assets/images/bottom/${val}/fenzu.png`)
        this.fenzuhanhua = require(`@/assets/images/bottom/${val}/fenzuhanhua.png`)
        this.fenzuhanhuaEnter = require(`@/assets/images/bottom/${val}/fenzuhanhua2.png`)
        this.fenzuhanhuaLeave = require(`@/assets/images/bottom/${val}/fenzuhanhua.png`)
        this.gengxin = require(`@/assets/images/bottom/${val}/gengxin.png`)
        this.gengxinEnter = require(`@/assets/images/bottom/${val}/gengxin2.png`)
        this.gengxinLeave = require(`@/assets/images/bottom/${val}/gengxin.png`)
        this.guaduan = require(`@/assets/images/bottom/${val}/guaduan.png`)
        this.guaduanEnter = require(`@/assets/images/bottom/${val}/guaduan2.png`)
        this.guaduanLeave = require(`@/assets/images/bottom/${val}/guaduan.png`)
        this.guanbihuiyi = require(`@/assets/images/bottom/${val}/guanbihuiyi.png`)
        this.guanbihuiyiEnter = require(`@/assets/images/bottom/${val}/guanbihuiyi2.png`)
        this.guanbihuiyiLeave = require(`@/assets/images/bottom/${val}/guanbihuiyi.png`)
        this.hujiao = require(`@/assets/images/bottom/${val}/hujiao.png`)
        this.hujiaoEnter = require(`@/assets/images/bottom/${val}/hujiao2.png`)
        this.hujiaoLeave = require(`@/assets/images/bottom/${val}/hujiao.png`)
        this.jianting = require(`@/assets/images/bottom/${val}/jianting.png`)
        this.jiantingEnter = require(`@/assets/images/bottom/${val}/jianting2.png`)
        this.jiantingLeave = require(`@/assets/images/bottom/${val}/jianting.png`)
        this.jieshu = require(`@/assets/images/bottom/${val}/jieshu.png`)
        this.jieshuEnter = require(`@/assets/images/bottom/${val}/jieshu2.png`)
        this.jieshuLeave = require(`@/assets/images/bottom/${val}/jieshu.png`)
        this.jingyin = require(`@/assets/images/bottom/${val}/jingyin.png`)
        this.jingyinEnter = require(`@/assets/images/bottom/${val}/jingyin2.png`)
        this.jingyinLeave = require(`@/assets/images/bottom/${val}/jingyin.png`)
        this.kaishihuiyi = require(`@/assets/images/bottom/${val}/kaishihuiyi.png`)
        this.kaishihuiyiEnter = require(`@/assets/images/bottom/${val}/kaishihuiyi2.png`)
        this.kaishihuiyiLeave = require(`@/assets/images/bottom/${val}/kaishihuiyi.png`)
        this.kongxian = require(`@/assets/images/bottom/${val}/kongxian.png`)
        this.kongxianEnter = require(`@/assets/images/bottom/${val}/kongxian.png`)
        this.kongxianLeave = require(`@/assets/images/bottom/${val}/kongxian2.png`)
        this.liandong = require(`@/assets/images/bottom/${val}/liandong.png`)
        this.liandongEnter = require(`@/assets/images/bottom/${val}/liandong2.png`)
        this.liandongLeave = require(`@/assets/images/bottom/${val}/liandong.png`)
        this.luxiangjilu = require(`@/assets/images/bottom/${val}/luxiangjilu.png`)
        this.luxiangjiluEnter = require(`@/assets/images/bottom/${val}/luxiangjilu2.png`)
        this.luxiangjiluLeave = require(`@/assets/images/bottom/${val}/luxiangjilu.png`)
        this.miyu = require(`@/assets/images/bottom/${val}/miyu.png`)
        this.miyuEnter = require(`@/assets/images/bottom/${val}/miyu2.png`)
        this.miyuLeave = require(`@/assets/images/bottom/${val}/miyu.png`)
        this.paiduitongzhi = require(`@/assets/images/bottom/${val}/paiduitongzhi.png`)
        this.paiduitongzhiEnter = require(`@/assets/images/bottom/${val}/paiduitongzhi2.png`)
        this.paiduitongzhiLeave = require(`@/assets/images/bottom/${val}/paiduitongzhi.png`)
        this.piliangshanchu = require(`@/assets/images/bottom/${val}/piliangshanchu.png`)
        this.piliangshanchuEnter = require(`@/assets/images/bottom/${val}/piliangshanchu2.png`)
        this.piliangshanchuLeave = require(`@/assets/images/bottom/${val}/piliangshanchu.png`)
        this.zhenling = require(`@/assets/images/bottom/${val}/zhenling.png`)

        this.qiangcha = require(`@/assets/images/bottom/${val}/qiangcha.png`)
        this.qiangchaEnter = require(`@/assets/images/bottom/${val}/qiangcha2.png`)
        this.qiangchaLeave = require(`@/assets/images/bottom/${val}/qiangcha.png`)
        this.qiangchai = require(`@/assets/images/bottom/${val}/qiangchai.png`)
        this.qiangchaiEnter = require(`@/assets/images/bottom/${val}/qiangchai2.png`)
        this.qiangchaiLeave = require(`@/assets/images/bottom/${val}/qiangchai.png`)
        this.quantijingyin = require(`@/assets/images/bottom/${val}/quantijingyin.png`)
        this.quantijingyinEnter = require(`@/assets/images/bottom/${val}/quantijingyin2.png`)
        this.quantijingyinLeave = require(`@/assets/images/bottom/${val}/quantijingyin.png`)
        this.quxiaojingyin = require(`@/assets/images/bottom/${val}/quxiaojingyin.png`)
        this.quxiaojingyinEnter = require(`@/assets/images/bottom/${val}/quxiaojingyin2.png`)
        this.quxiaojingyinLeave = require(`@/assets/images/bottom/${val}/quxiaojingyin.png`)
        this.quxiaoquantijingyin = require(`@/assets/images/bottom/${val}/quxiaoquantijingyin.png`)
        this.quxiaoquantijingyinEnter = require(`@/assets/images/bottom/${val}/quxiaoquantijingyin2.png`)
        this.quxiaoquantijingyinLeave = require(`@/assets/images/bottom/${val}/quxiaoquantijingyin.png`)
        this.shanchu = require(`@/assets/images/bottom/${val}/shanchu.png`)
        this.shanchuEnter = require(`@/assets/images/bottom/${val}/shanchu2.png`)
        this.shanchuLeave = require(`@/assets/images/bottom/${val}/shanchu.png`)
        this.xiangqing = require(`@/assets/images/bottom/${val}/xiangqing.png`)
        this.xiangqingEnter = require(`@/assets/images/bottom/${val}/xiangqing2.png`)
        this.xiangqingLeave = require(`@/assets/images/bottom/${val}/xiangqing.png`)
        this.yaoqing = require(`@/assets/images/bottom/${val}/yaoqing.png`)
        this.yaoqingEnter = require(`@/assets/images/bottom/${val}/yaoqing2.png`)
        this.yaoqingLeave = require(`@/assets/images/bottom/${val}/yaoqing.png`)
        this.yichu = require(`@/assets/images/bottom/${val}/yichu.png`)
        this.yichuEnter = require(`@/assets/images/bottom/${val}/yichu2.png`)
        this.yichuLeave = require(`@/assets/images/bottom/${val}/yichu.png`)
        this.yinliang = require(`@/assets/images/bottom/${val}/yinliang.png`)
        this.yinliangEnter = require(`@/assets/images/bottom/${val}/yinliang2.png`)
        this.yinliangLeave = require(`@/assets/images/bottom/${val}/yinliang.png`)
        this.yinliangjia = require(`@/assets/images/bottom/${val}/yinliangjia.png`)
        this.yinliangjiaEnter = require(`@/assets/images/bottom/${val}/yinliangjia2.png`)
        this.yinliangjiaLeave = require(`@/assets/images/bottom/${val}/yinliangjia.png`)
        this.yinliangjian = require(`@/assets/images/bottom/${val}/yinliangjian.png`)
        this.yinliangjianEnter = require(`@/assets/images/bottom/${val}/yinliangjian2.png`)
        this.yinliangjianLeave = require(`@/assets/images/bottom/${val}/yinliangjian.png`)
        this.zanting = require(`@/assets/images/bottom/${val}/zanting.png`)
        this.zantingEnter = require(`@/assets/images/bottom/${val}/zanting2.png`)
        this.zantingLeave = require(`@/assets/images/bottom/${val}/zanting.png`)
        this.zengjia = require(`@/assets/images/bottom/${val}/zengjia.png`)
        this.zengjiaEnter = require(`@/assets/images/bottom/${val}/zengjia2.png`)
        this.zengjiaLeave = require(`@/assets/images/bottom/${val}/zengjia.png`)
        this.zhuanjie = require(`@/assets/images/bottom/${val}/zhuanjie.png`)
        this.zhuanjieEnter = require(`@/assets/images/bottom/${val}/zhuanjie2.png`)
        this.zhuanjieLeave = require(`@/assets/images/bottom/${val}/zhuanjie.png`)
        this.zhuapaijilu = require(`@/assets/images/bottom/${val}/zhuapaijilu.png`)
        this.zhuapaijiluEnter = require(`@/assets/images/bottom/${val}/zhuapaijilu2.png`)
        this.zhuapaijiluLeave = require(`@/assets/images/bottom/${val}/zhuapaijilu.png`)
        this.zidongjieting = require(`@/assets/images/bottom/${val}/zidongjieting.png`)
        this.zidongjietingEnter = require(`@/assets/images/bottom/${val}/zidongjieting.png`)
        this.zidongjietingLeave = require(`@/assets/images/bottom/${val}/zidongjieting2.png`)
        this.lixianrenwu = require(`@/assets/images/bottom/${val}/lixianrenwu.png`)
        this.lixianrenwuEnter = require(`@/assets/images/bottom/${val}/lixianrenwu2.png`)
        this.lixianrenwuLeave = require(`@/assets/images/bottom/${val}/lixianrenwu.png`)
        this.renwutongbu = require(`@/assets/images/bottom/${val}/renwutongbu.png`)
        this.renwutongbuEnter = require(`@/assets/images/bottom/${val}/renwutongbu2.png`)
        this.renwutongbuLeave = require(`@/assets/images/bottom/${val}/renwutongbu.png`)
        this.xiugaiyinliang = require(`@/assets/images/bottom/${val}/xiugaiyinliang.png`)
        this.xiugaiyinliangEnter = require(`@/assets/images/bottom/${val}/xiugaiyinliang2.png`)
        this.xiugaiyinliangLeave = require(`@/assets/images/bottom/${val}/xiugaiyinliang.png`)
        this.shangchuanchangjingtu = require(`@/assets/images/bottom/${val}/shangchuanchangjingtu.png`)
        this.shangchuanchangjingtuEnter = require(`@/assets/images/bottom/${val}/shangchuanchangjingtu2.png`)
        this.shangchuanchangjingtuLeave = require(`@/assets/images/bottom/${val}/shangchuanchangjingtu.png`)
        this.lixian = require(`@/assets/images/bottom/${val}/lixian.png`)
        this.topImg = require(`@/assets/images/bottom/${val}/top.png`)
        this.cameraInterval = require(`@/assets/images/bottom/${val}/camerafor.png`)
        this.cameraIntervalEnter = require(`@/assets/images/bottom/${val}/camerafor2.png`)
        this.cameraIntervalLeave = require(`@/assets/images/bottom/${val}/camerafor.png`)

        this.fullScreen = require(`@/assets/images/bottom/${val}/full.png`)
        this.fullScreenEnter = require(`@/assets/images/bottom/${val}/full2.png`)
        this.fullScreenLeave = require(`@/assets/images/bottom/${val}/full.png`)
        this.joinMeeting = require(`@/assets/images/bottom/${val}/join.png`)
        this.joinMeetingEnter = require(`@/assets/images/bottom/${val}/join2.png`)
        this.joinMeetingLeave=require(`@/assets/images/bottom/${val}/join.png`)
        this.disableCamera = require(`@/assets/images/bottom/${val}/mute_camera.png`)
        this.disableCameraEnter = require(`@/assets/images/bottom/${val}/mute_camera2.png`)
        this.disableCameraLeave = require(`@/assets/images/bottom/${val}/mute_camera.png`)
        this.enableCamera = require(`@/assets/images/bottom/${val}/unMute_camera.png`)
        this.enableCameraEnter = require(`@/assets/images/bottom/${val}/unMute_camera2.png`)
        this.enableCameraLeave = require(`@/assets/images/bottom/${val}/unMute_camera.png`)
        this.settingImage = require(`@/assets/images/bottom/${val}/setting.png`)
        this.settingImageEnter = require(`@/assets/images/bottom/${val}/setting2.png`)
        this.settingImageLeave = require(`@/assets/images/bottom/${val}/setting.png`)
        //this.mapImage.source.default = require(`@/assets/images/map/v2/default/default_${this.$store.state.app.theme}_${this.$store.state.app.local}.jpg`)

        this.playVideoRecordImage = require(`@/assets/images/bottom/${val}/bofangluxiang.png`);
        this.playVideoRecordImageEnter = require(`@/assets/images/bottom/${val}/bofangluxiang2.png`);
        this.playVideoRecordImageLeave = require(`@/assets/images/bottom/${val}/bofangluxiang.png`);
        this.playAudioRecordImage = require(`@/assets/images/bottom/${val}/bofangluyin.png`);
        this.playAudioRecordImageEnter = require(`@/assets/images/bottom/${val}/bofangluyin2.png`);
        this.playAudioRecordImageLeave = require(`@/assets/images/bottom/${val}/bofangluyin.png`);
        this.viewImgRecordImage = require(`@/assets/images/bottom/${val}/chakanjietu.png`);
        this.viewImgRecordImageEnter = require(`@/assets/images/bottom/${val}/chakanjietu2.png`);
        this.viewImgRecordImageLeave = require(`@/assets/images/bottom/${val}/chakanjietu.png`);
        this.downloadImgImage = require(`@/assets/images/bottom/${val}/xiazaijietu.png`);
        this.downloadImgImageEnter = require(`@/assets/images/bottom/${val}/xiazaijietu2.png`);
        this.downloadImgImageLeave = require(`@/assets/images/bottom/${val}/xiazaijietu.png`);
        this.downloadVideoImage = require(`@/assets/images/bottom/${val}/xiazailuxiang.png`);
        this.downloadVideoImageEnter = require(`@/assets/images/bottom/${val}/xiazailuxiang2.png`);
        this.downloadVideoImageLeave = require(`@/assets/images/bottom/${val}/xiazailuxiang.png`);
        this.downloadAudioImage = require(`@/assets/images/bottom/${val}/xiazailuyin.png`);
        this.downloadAudioImageEnter = require(`@/assets/images/bottom/${val}/xiazailuyin2.png`);
        this.downloadAudioImageLeave = require(`@/assets/images/bottom/${val}/xiazailuyin.png`);


        this.mapImage.source.default = require(`@/assets/images/map/v2/default/default_new_${this.$store.state.app.local}.png`)

        //图标切换
        if ('white' === val) {
          this.broad_svg = 'broad_b'
          this.car_svg = 'car_b'
          this.door_svg = 'door_b'
          this.full_svg = 'full_b'
          this.idel_svg = 'idel_b'
          this.logout_svg = 'logout_b'
          this.mobile_svg = 'mobile_b'
          this.offline_svg = 'offline_b'
          this.other_svg = 'other_b'
          this.partBroad_svg = 'part_broad_b'
          this.partConf_svg = 'part_conf_b'
          this.partPro_svg = 'part_pro_b'
          this.partDown_svg = 'part_down_b'
          this.partUp_svg = 'part_up_b'
          this.pc_svg = 'pc_b'
          this.ring_svg = 'ring_b'
          this.selected_svg = 'selected_b'
          this.unselected_svg = 'unselected_b'
          this.setting_svg = 'setting_b'
          this.speak_svg = 'speak_b'
          this.talking_svg = 'talking_b'
          this.unknow_svg = 'unknow_b'
          this.view_svg = 'view_b'
          this.app_svg = 'app_svg_b'
          this.voice_svg = 'voice_b'
          //main
          this.main_talking_svg = 'talking_c'
          this.main_broading_svg = 'broading_b'
          this.main_ring_svg = 'ring_c'
          this.main_idel_svg = 'idel_c'
          this.main_offline_svg = 'offline_c'
          this.main_unknow_svg = 'unknow_c'
          this.cascade_refresh = 'cascadeRefresh_b'
          this.header_top_left = 'top-left'
          this.header_top_mean = 'top-mean'
          this.header_top_mean_b = 'top-mean-b'
          this.cas_full_svg = 'cascadeFullWhite'


          this.logoEN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].whiteLogo.en
          this.logoCN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].whiteLogo.zh
          this.logoTW = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].whiteLogo.tw

          this.mapImage.options = {
            review: 'map_white_review',
            distance: 'map_white_distance',
            circle: 'map_white_circle',
            box: 'map_white_box',
            fence: 'map_white_fence',
            zoomout: 'map_white_zoomout',
            zoomin: 'map_white_zoomin',
            upload: 'map_white_upload',
            scene_manager: 'map_white_scene_manager',
            track: 'map_white_track',
            view: 'map_view',
            view_off: 'mapviewoff',
            lock: 'map_lock',
            unlock: 'map_unlock',
          }
        }else if ('blue' === val) {
          this.broad_svg = 'broad'
          this.car_svg = 'car'
          this.door_svg = 'door'
          this.full_svg = 'full'
          this.idel_svg = 'idel'
          this.logout_svg = 'logout'
          this.mobile_svg = 'mobile'
          this.offline_svg = 'offline'
          this.other_svg = 'other'
          this.partBroad_svg = 'part_broad'
          this.partConf_svg = 'part_conf'
          this.partPro_svg = 'part_pro'
          this.partDown_svg = 'part_down'
          this.partUp_svg = 'part_up'
          this.pc_svg = 'pc'
          this.ring_svg = 'ring'
          this.selected_svg = 'selected'
          this.unselected_svg = 'unselected'
          this.setting_svg = 'setting'
          this.speak_svg = 'speak'
          this.talking_svg = 'talking'
          this.unknow_svg = 'unknow'
          this.view_svg = 'view'
          this.app_svg = 'app_svg'
          this.voice_svg = 'voice'
          //main
          this.main_talking_svg = 'talking'
          this.main_broading_svg = 'broading_c'
          this.main_ring_svg = 'ring'
          this.main_idel_svg = 'idel'
          this.main_offline_svg = 'offline'
          this.main_unknow_svg = 'unknow'
          this.cascade_refresh = 'cascadeRefresh'
          this.header_top_left = 'top-left'
          this.cas_full_svg = 'cascadeFullBlack'

          this.logoEN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blueLogo.en
          this.logoCN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blueLogo.zh
          this.logoTW = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blueLogo.tw

          this.mapImage.options = {
            review: 'map_black_review',
            distance: 'map_black_distance',
            circle: 'map_black_circle',
            box: 'map_black_box',
            fence: 'map_black_fence',
            zoomout: 'map_black_zoomout',
            zoomin: 'map_black_zoomin',
            upload: 'map_black_upload',
            scene_manager: 'map_black_scene_manager',
            track: 'map_black_track',
            view: 'map_view',
            view_off: 'mapviewoff',
            lock: 'map_lock',
            unlock: 'map_unlock',
          }
        }else if ('black' === val) {
          this.broad_svg = 'broad'
          this.car_svg = 'car'
          this.door_svg = 'door'
          this.full_svg = 'full'
          this.idel_svg = 'idel'
          this.logout_svg = 'logout'
          this.mobile_svg = 'mobile'
          this.offline_svg = 'offline'
          this.other_svg = 'other'
          this.partBroad_svg = 'part_broad'
          this.partConf_svg = 'part_conf'
          this.partPro_svg = 'part_pro'
          this.partDown_svg = 'part_down_c'
          this.partUp_svg = 'part_up_c'
          this.pc_svg = 'pc'
          this.ring_svg = 'ring'
          this.selected_svg = 'selected'
          this.unselected_svg = 'unselected'
          this.setting_svg = 'setting'
          this.speak_svg = 'speak'
          this.talking_svg = 'talking'
          this.unknow_svg = 'unknow'
          this.view_svg = 'view'
          this.app_svg = 'app_svg'
          this.voice_svg = 'voice'
          //main
          this.main_talking_svg = 'talking'
          this.main_broading_svg = 'broading_c'
          this.main_ring_svg = 'ring'
          this.main_idel_svg = 'idel'
          this.main_offline_svg = 'offline'
          this.main_unknow_svg = 'unknow'
          this.cascade_refresh = 'cascadeRefresh'
          this.header_top_left = 'top-left'
          this.cas_full_svg = 'cascadeFullBlack'

          this.logoEN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blackLogo.en
          this.logoCN = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blackLogo.zh
          this.logoTW = this.$config[`${this.$store.state.cacheData.isFusion?'intercom':'pa'}`].blackLogo.tw

          this.mapImage.options = {
            review: 'map_black_review',
            distance: 'map_black_distance',
            circle: 'map_black_circle',
            box: 'map_black_box',
            fence: 'map_black_fence',
            zoomout: 'map_black_zoomout',
            zoomin: 'map_black_zoomin',
            upload: 'map_black_upload',
            scene_manager: 'map_black_scene_manager',
            track: 'map_black_track',
            view: 'map_view',
            view_off: 'mapviewoff',
            lock: 'map_lock',
            unlock: 'map_unlock',
          }
        }
      }
    },
    '$store.state.app.local':{
      deep:true,
      handler(val){
        this.mapImage.source.default = require(`@/assets/images/map/v2/default/default_new_${this.$store.state.app.local}.png`)
      }
    }
  },
  mounted() {
    let buttons = $('.button_father')
    const vm = this
    if (buttons) {
      buttons.bind('mouseover',function(){
        // 白色主题 dock 用 CSS 悬停，hue-rotate 会把蓝圆标滤成橄榄绿
        if (vm.$store && vm.$store.state.app.theme === 'white') {
          return
        }
        let oldFilter = this.style.filter
        if (oldFilter && oldFilter == 'grayscale(100%)') {
          return
        }
        if ($(this).find('.button_son_disable').length) {
          return
        }
        this.style.filter = 'hue-rotate(215deg)'
      })
      buttons.bind('mouseout', function () {
        let oldFilter = this.style.filter
        if (oldFilter && oldFilter == 'hue-rotate(215deg)') {
          this.style.filter = 'unset'
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/base.js